/*
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import config from './config';
import LoginIdp from './LoginIdp';
import Routes from './components/Routes';
import TopBar from './components/TopBar';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import {lightTheme, darkTheme } from './theme';
import { CssBaseline } from '@mui/material';
import { toggleTheme } from './app/themeSlice';
import { useDispatch } from 'react-redux';

const oktaAuth = new OktaAuth(config.oidc);

const App = () => {



  // Auto redirect to new portal
  useEffect(() => {
    window.location.href = 'https://aihub.stage.commandcentral.com/ai-guru';
  }, []);


  //const authState = useState(oktaAuth.authStateManager.getAuthState();
  const [isLoggedIn, setIsLoggedIn] = React.useState(true);
  const isDarkMode = useSelector((state) => state.theme.mode === 'dark');
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth,  originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };
  const dispatch = useDispatch();

  const selectedMenu = useSelector((state) => state.menu.selectedMenu);

  const onLogin = (isLogin) => {
    console.log("App:onLogin:", isLogin);
    setIsLoggedIn(isLogin);
  };

  const toggleThemeHandler = () => {
    dispatch(toggleTheme()); // Dispatch toggleTheme action
  };

  // Dynamically switch CSS files when the theme changes
  useEffect(() => {
    const linkElement = document.getElementById('theme-css');
    //Toggle betwen msi-cobalt themes
    if (linkElement) {
      linkElement.href = isDarkMode
        ? '/css/cobalt-dark-core.min.css'
        : '/css/cobalt-light-core.min.css';
    }
  }, [isDarkMode]);

  console.log("App:isLoggedIn", isLoggedIn);

  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <CssBaseline />
      <link
        id="theme-css"
        rel="stylesheet"
        href="/css/cobalt-light-core.min.css" // Default to light theme
      />
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <LoginIdp onLogin={onLogin} />
        <TopBar selectedMenu={selectedMenu} isLoggedIn={isLoggedIn} toggleTheme={toggleThemeHandler} />
        <Routes isLoggedIn={isLoggedIn} />
      </Security>
    </ThemeProvider>
  );
};
export default App;
